/**
 * @generated SignedSource<<799bb86b4f7f27244a94875a8780a85a>>
 * @relayHash 2e14c43d77090c83da4edcc2dcdc3644
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 13299c79730dea91e1997c48abc26a15c9f94dde95bf3e45dc05dcdca7e2eb2c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null | undefined;
  userId: string;
};
export type ThreadsV2_Query$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
  isEnabled: boolean;
  suggestedActionsV2Enabled: boolean;
};
export type ThreadsV2_Query$data = {
  readonly convoai_homeThreads?: {
    readonly " $fragmentSpreads": FragmentRefs<"RecommendedFeedInternal_AtlassianRecommendedFeed">;
  } | null | undefined;
};
export type ThreadsV2_Query = {
  response: ThreadsV2_Query$data;
  variables: ThreadsV2_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedActionsV2Enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 300
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:300)"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v11 = [
  (v3/*: any*/)
],
v12 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v8/*: any*/),
        (v2/*: any*/)
      ]
    },
    (v2/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "suggestedActionsV2Enabled",
                    "variableName": "suggestedActionsV2Enabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "RecommendedFeedInternal_AtlassianRecommendedFeed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThreadsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConvoAiHomeThread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "summary"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConvoAiHomeThreadSource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "ari"
                              },
                              (v5/*: any*/)
                            ],
                            "type": "ConvoAiHomeThreadsFirstPartySource"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "ConvoAiHomeThreadSuggestedAction",
                        "kind": "LinkedField",
                        "name": "suggestedActions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConvoAiHomeThreadsFirstPartySource"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "action"
                          },
                          {
                            "condition": "suggestedActionsV2Enabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "concreteType": "ConfluenceUserInfo",
                                                "kind": "LinkedField",
                                                "name": "author",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v8/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "picture"
                                                      },
                                                      (v2/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                  },
                                                  (v2/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "ConfluenceContentVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "createdAt"
                                                  }
                                                ]
                                              },
                                              (v9/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "name": "container",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v3/*: any*/),
                                                      (v10/*: any*/)
                                                    ],
                                                    "type": "ConfluencePage"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v11/*: any*/),
                                                    "type": "ConfluenceBlogPost"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v11/*: any*/),
                                                    "type": "ConfluenceWhiteboard"
                                                  },
                                                  (v7/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "ConfluenceFooterComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v3/*: any*/),
                                              (v12/*: any*/),
                                              (v9/*: any*/),
                                              (v10/*: any*/)
                                            ],
                                            "type": "ConfluencePage"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v3/*: any*/),
                                              (v12/*: any*/),
                                              (v9/*: any*/)
                                            ],
                                            "type": "ConfluenceBlogPost"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "13299c79730dea91e1997c48abc26a15c9f94dde95bf3e45dc05dcdca7e2eb2c",
    "metadata": {},
    "name": "ThreadsV2_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "164d0eebed4738877139818c541a2de0";

export default node;
